/* Juniper theme — small interactions ported from the prototype */

// Product page: quantity stepper
function stepQty(d) {
  var i = document.getElementById('qty');
  if (!i) return;
  var n = Math.max(1, (parseInt(i.value, 10) || 1) + d);
  i.value = n;
}

// Product page: gallery thumbnail swap
function swap(el, src) {
  var m = document.getElementById('pdp-main-img');
  if (m) m.src = src;
  document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
  el.classList.add('active');
}

// Home: scroll-driven parallax zoom on the hero and gifting images
(function () {
  var els = [
    { img: document.querySelector('.hero-bg'), box: document.querySelector('.hero') },
    { img: document.querySelector('.gifting-img img'), box: document.querySelector('.gifting-img') }
  ].filter(function (e) { return e.img && e.box; });
  if (!els.length) return;

  function update() {
    var vh = window.innerHeight;
    els.forEach(function (e) {
      var rect = e.box.getBoundingClientRect();
      var p = (vh - rect.top) / (vh + rect.height);
      p = Math.max(0, Math.min(1, p));
      var scale = 1.08 + p * 0.16;
      var ty = (p - 0.5) * 6;
      e.img.style.transform = 'translateY(' + ty.toFixed(2) + '%) scale(' + scale.toFixed(3) + ')';
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
